import { BoxSlotTemplateFormView } from "@/modules/boxSlotTemplate/components/boxSlotTemplateFormView"
import { useBoxSlotTemplate } from "@/modules/boxSlotTemplate/hooks/useBoxSlotTemplates"

type BoxSlotTemplateFormUpdateProps = {
  boxSlotTemplateId: string
  boxProgramId: string
} & React.ComponentProps<"div">

export const BoxSlotTemplateFormUpdate = ({
  boxSlotTemplateId,
  boxProgramId,
  className,
  ...props
}: BoxSlotTemplateFormUpdateProps) => {
  const { data: boxSlotTemplate } = useBoxSlotTemplate(boxProgramId, boxSlotTemplateId)

  return (
    <BoxSlotTemplateFormView
      boxSlotTemplate={boxSlotTemplate}
      boxProgramId={boxProgramId}
      className={className}
      {...props}
    />
  )
}
